/*
Sohel 03/20/2023 2699762545 changed label
Ravi  03/20/2023 2699762545 Added status
Guru Prasad  03/20/2023 2699762545 Fixed scroll issues in prior letter
Sohel  03/23/2023 2699762545 Added Letter type, created date and create by fields
Dilip  03/23/2023 2699762545 added to show completed fields
Prakash 03/24/2023 2699762545 Added conditional Reset save buttons.
Prakash 03/27/2023 2699762545 Fixed Responsiveness issue.
Guru Prasad 03/30/2023 2699762545 Added State for the Usage .
Ravi 04/12/2023 2699762545 Added session storage
Akhila 05/24/2024 2699762545 role access implemeneted
Akhila 06/08/2023 2699762545 created date change to date created field and column
Sohel 11/11/2023 2699762545 Fixed PriorLetters Save and Letter Type Pre populate Issue
*/
import React, {useContext, useEffect, useState, useRef} from 'react';
import {Form, Formik} from 'formik';
import {ThemeContext} from '../../../themes/ThemeProvider';
import {Button, FormHelperText, TextField} from '@material-ui/core';
import {useDispatch} from 'react-redux';
import {getAllReportCreatedForData} from '../../../redux/reducers/ReportMaster';
import {getClientCodeDropDownData} from '../../../redux/reducers/TriggerGroup';
import LetterMaintenanceSearchTable from './LetterMaintenanceSearchTable';
import GuiAutoComplete from '../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../components/FormComponents/GuiTextField';
import {filteredCheckedData2, tempSelectFunc2} from '../../../util/Functions';
import {useSelector} from 'react-redux';
import {KeyboardDatePicker, MuiPickersUtilsProvider} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import {getDropDownData} from '../../../redux/reducers/LetterMaintainance/NewLetterMaintenance';
import {LETTER_TYPE} from '../../../constants/Lookup';
import * as Yup from 'yup';
import {createdByOptions} from '../../../util/CreatedByForOptions';
const StatusOptions = [
  {key: 'Y', value: 'Draft'},
  {key: 'N', value: 'Completed'},
];

function SearchLetterMaintenance({
  setValue = () => {},
  isPriorLetters,
  lettersValues,
  setTempSelectedRows,
  tempSelectedRows,
  handlePriorClose,
  setLettersValues = () => {},
  lettersDeletedIds,
  setLettersDeletedIds = () => {},
  setLetterMaintenanceData,
  setEditExisting,
  letterType,
}) {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const [searchData, setSearchData] = useState({});
  const [submit, setSubmit] = useState(false);
  const tempUnCheckedRef = useRef();
  const dispatch = useDispatch();
  const initialValues = {
    letterCode: '',
    description: '',
    isDraft: isPriorLetters ? {key: 'N', value: 'Completed'} : '',
    createdDate: null,
    letterType: isPriorLetters && letterType ? {value:letterType} :"",
  };
  const validationSchema = Yup.object().shape({
    createdDate: Yup.date().typeError('Invalid date format').nullable(),
  });
  useEffect(() => {
    if (setEditExisting) {
      setEditExisting(false);
    }
  }, []);

  useEffect(() => {
    if (isPriorLetters) {
      setSearchData({
        ...searchData,
        isDraft: {key: 'N', value: 'Completed'},
        letterType: letterType ? {value:letterType} :""
      });
    }
  }, [isPriorLetters]);

  const handleSubmit = (values) => {
    sessionStorage.setItem('searchLetterMaintenance', JSON.stringify(values));
    setSearchData(values);
    setSubmit(true);
  };
  useEffect(() => {
    dispatch(getClientCodeDropDownData());
    dispatch(getAllReportCreatedForData());
    dispatch(getDropDownData());
  }, []);

  const onClear = () => {
    const data = {
      letterCode: '',
      description: '',
      isDraft: isPriorLetters ? {key: 'N', value: 'Completed'} :"",
      letterType: isPriorLetters && letterType ? {value:letterType} :"",
      createdDate: null,
    };
    setSearchData(data);
    sessionStorage.removeItem('searchLetterMaintenance');
  };
  const searchSessionLetterMaintenance = JSON.parse(
    sessionStorage.getItem('searchLetterMaintenance'),
  );
  useEffect(() => {
    if (setTempSelectedRows) {
      setTempSelectedRows([]);
      tempUnCheckedRef.current = [];
    }
  }, []);

  const {
    dropDownData,
    createdByData,
  } = useSelector(({newLetterMaintenance}) => newLetterMaintenance);

  const getOptions = (typeCode) => {
    let label = [];
    label = dropDownData && dropDownData[typeCode] ? dropDownData[typeCode] : [];
    return label;
  };

  return (
    <div>
      <div className={isPriorLetters ? `col-12` : ' '}>
        <h2 className="search-title">Letter Search</h2>
        <Formik
          onSubmit={(values) => handleSubmit(values)}
          initialValues={
            searchSessionLetterMaintenance && !isPriorLetters ?
              searchSessionLetterMaintenance :
              initialValues
          }
          enableReinitialize
          validationSchema={validationSchema}
        >
          {(props) => {
            const {
              values,
              errors,
              handleChange,
              handleBlur,
              resetForm,
              setFieldValue,
              touched,
            } = props;

            return (
              <div>
                <Form autoComplete="off">
                  <div className="form-row standard-field-textfields new-standard-textfields">
                    <div className={`col-sm-6 col-xs-6 col-md-4 col-lg-3 col-xl-3 form-group`}>
                      <TextField
                        margin="dense"
                        variant="outlined"
                        className={`${classes.labelName}`}
                        placeholder={`Enter Letter Code`}
                        label="Letter Code"
                        name="letterCode"
                        value={values?.letterCode?.toUpperCase()}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                        touched={touched.letterCode}
                      />
                    </div>
                    <div className={`col-sm-6 col-xs-6 col-md-4 col-lg-3 col-xl-3 form-group`}>
                      <TextField
                        margin="dense"
                        variant="outlined"
                        className={`${classes.labelName}`}
                        name="description"
                        placeholder={`Enter Letter Description`}
                        label="Letter Description"
                        value={values.description}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                      />
                    </div>

                    <div className={`"col-sm-6 col-md-4 col-lg-3 col-xl-3 form-group"`}>
                      <GuiAutoComplete
                        classes={{
                          option: classes.option,
                        }}
                        name="letterType"
                        id="letterType"
                        size="small"
                        value={values.letterType}
                        disabled={isPriorLetters}
                        options={getOptions(LETTER_TYPE).length > 0 ? getOptions(LETTER_TYPE) : []}
                        getOptionLabel={(option) => {
                          return option?.value ? option?.value : '';
                        }}
                        onChange={(e, value) => {
                          handleChange(e);
                          setFieldValue('letterType', value);
                        }}
                        renderInput={(params) => (
                          <div className="select-field">
                            <GuiTextField
                              {...params}
                              className={`${classes.labelName}`}
                              variant="outlined"
                              margin="dense"
                              label="Letter Type"
                              placeholder="Select Letter Type"
                            />
                          </div>
                        )}
                      />
                    </div>

                    <div className={`col-sm-6 col-xs-6 col-md-4 col-lg-3 col-xl-3 form-group`}>
                      <GuiAutoComplete
                        classes={{
                          option: classes.option,
                        }}
                        name="createdBy"
                        id="createdBy"
                        size="small"
                        value={values.createdBy}
                        options={createdByData}
                        getOptionLabel={(option) => {
                          return option && option?.userLoginName ? option?.userLoginName : '';
                        }}
                        renderOption={(option) => {
                          return createdByOptions(option);
                        }}
                        onChange={(e, value) => {
                          setFieldValue('createdBy', value);
                        }}
                        renderInput={(params) => (
                          <div className="select-field">
                            <GuiTextField
                              {...params}
                              className={`${classes.labelName}`}
                              variant="outlined"
                              margin="dense"
                              label="Created By"
                              placeholder="Select Created By"
                            />
                          </div>
                        )}
                      />
                    </div>

                    <div className={`col-sm-6 col-xs-6 col-md-4 col-lg-3 col-xl-3 form-group`}>
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                          format="MM/dd/yyyy"
                          className={`${classes.labelName}`}
                          placeholder="MM/DD/YYYY"
                          fullWidth
                          value={values.createdDate}
                          name="createdDate"
                          onBlur={handleBlur}
                          inputVariant="outlined"
                          helperText=""
                          label="Date Created"
                          onChange={(val) => {
                            setFieldValue('createdDate', val);
                          }}
                          autoOk
                          margin="dense"
                          touched={touched?.createdDate}
                          error={Boolean(touched?.createdDate && errors?.createdDate)}
                        />
                      </MuiPickersUtilsProvider>
                      <FormHelperText variant="outlined">
                        {touched.createdDate && errors.createdDate ? errors.createdDate : ''}
                      </FormHelperText>
                    </div>
                    <div className={`col-sm-6 col-xs-6 col-md-4 col-lg-3 col-xl-3 form-group`}>
                      <GuiAutoComplete
                        classes={{
                          option: classes.option,
                        }}
                        name="isDraft"
                        id="isDraft"
                        size="small"
                        options={StatusOptions}
                        value={values.isDraft}
                        disabled={isPriorLetters}
                        autoHighlight
                        getOptionLabel={(option) => {
                          return option && option?.value;
                        }}
                        onChange={(e, value) => {
                          handleChange(e);
                          setFieldValue('isDraft', value);
                        }}
                        renderInput={(params) => (
                          <div className="select-field">
                            <GuiTextField
                              {...params}
                              className={`${classes.labelName}`}
                              variant="outlined"
                              margin="dense"
                              label="Status"
                              placeholder="Select Status"
                            />
                          </div>
                        )}
                      />
                    </div>
                    {!isPriorLetters && (
                      <div className="col-md-12 col-lg-3 col-xl-3  mb-3">
                        <div className="d-flex align-items-center justify-content-md-center justify-content-lg-start">
                          <Button
                            variant="outlined"
                            className={`mr-1 reset-btn`}
                            onClick={() => {
                              setSubmit(true);
                              resetForm();
                              onClear();
                            }}
                          >
                            Reset
                          </Button>
                          <Button type="submit" variant="outlined" className={`ml-1 search-btn`}>
                            Search
                          </Button>
                        </div>
                      </div>
                    )}
                  </div>

                  {isPriorLetters && (
                    <div className="form-row standard-field-textfields align-items-center new-standard-textfields">
                      <div className="col-md-6 form-group">
                        <div className="d-flex justify-content-end">
                          <Button
                            variant="outlined"
                            className={`mr-1 reset-btn`}
                            onClick={() => {
                              setSubmit(true);
                              resetForm();
                              onClear();
                            }}
                          >
                            Reset
                          </Button>
                          <Button type="submit" variant="outlined" className={`ml-1 search-btn`}>
                            Search
                          </Button>
                        </div>
                      </div>
                      <div className="col-md-6 form-group">
                        <div className="d-flex justify-content-end mb-2">
                          <Button
                            variant="outlined"
                            className={`reset-btn mr-2`}
                            onClick={() => {
                              handlePriorClose();
                            }}
                          >
                            Close
                          </Button>
                          <Button
                            variant="outlined"
                            className={`search-btn`}
                            onClick={() => {
                              const obj = tempSelectFunc2('letterCode', tempUnCheckedRef);
                              const [newSelectedRows, newUnSelectedRows] = filteredCheckedData2(
                                lettersValues?.priorLetters,
                                obj,
                                'letterCode',
                              );
                              const allSelectedRows = [...newSelectedRows, ...tempSelectedRows];
                              setLettersValues('priorLetters', allSelectedRows);

                              if (newUnSelectedRows.length > 0) {
                                const allDeleteIds = [];
                                newUnSelectedRows.forEach((el) => {
                                  if (el.precedingLetterId) {
                                    allDeleteIds.push(el.precedingLetterId);
                                  }
                                });

                                const ids = [...lettersDeletedIds, ...allDeleteIds];
                                setLettersDeletedIds(ids);
                              }
                              setTempSelectedRows([]);
                              handlePriorClose();
                            }}
                          >
                            Save
                          </Button>
                        </div>
                      </div>
                    </div>
                  )}
                </Form>
              </div>
            );
          }}
        </Formik>
        <LetterMaintenanceSearchTable
          setValue={setValue}
          searchData={searchData}
          submit={submit}
          isPriorLetters={isPriorLetters}
          setSubmit={setSubmit}
          lettersValues={lettersValues}
          setTempSelectedRows={setTempSelectedRows}
          tempSelectedRows={tempSelectedRows}
          tempUnCheckedRef={tempUnCheckedRef}
          setEditExisting={setEditExisting}
          setLetterMaintenanceData={setLetterMaintenanceData}
        />
      </div>
    </div>
  );
}

export default SearchLetterMaintenance;
